import React from "react";


class BackgroundLayer extends React.Component {
  constructor(props) {
    super(props);

    this.images = {
      portrait: [
        "portrait-1.jpg",
        "portrait-2.jpg",
        "portrait-3.jpg",
        "portrait-4.jpg",
        "portrait-5.jpg",
        "portrait-6.jpg",
      ],
      landscape: [
        "landscape-1.jpg",
        "landscape-2.jpg",
        "landscape-3.jpg",
        "landscape-4.jpg",
        "landscape-5.jpg",
        "landscape-6.jpg",
        "landscape-7.jpg",
        "landscape-8.jpg",
        "landscape-9.jpg",
        "landscape-10.jpg",
        "landscape-11.jpg",
        "landscape-12.jpg",
        "landscape-13.jpg",
      ],
    };

    const isLandscape = window.matchMedia("(orientation: landscape)").matches;
    const selectedImages = isLandscape ? this.images.landscape : this.images.portrait;
    const randomImage = selectedImages[Math.floor(Math.random() * selectedImages.length)];

    this.state = {
      backgroundImage: randomImage,
    };
  }

  componentDidMount() {
    // Optional: auto-change if screen rotates
    this.orientationQuery = window.matchMedia("(orientation: landscape)");
    this.orientationQuery.addEventListener("change", this.handleOrientationChange);
  }

  componentWillUnmount() {
    if (this.orientationQuery) {
      this.orientationQuery.removeEventListener("change", this.handleOrientationChange);
    }
  }

  handleOrientationChange = (e) => {
    const isLandscape = e.matches;
    const selectedImages = isLandscape ? this.images.landscape : this.images.portrait;
    const randomImage = selectedImages[Math.floor(Math.random() * selectedImages.length)];

    this.setState({ backgroundImage: randomImage });
  };

  render() {
    const { backgroundImage } = this.state;
    const backgroundStyle = {
      position: "fixed",
      inset: 0,
      zIndex: -1,
      backgroundImage: `url(${this.props.imgPath}${backgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      width: "100vw",
      minWidth: "100%",
      // height: "calc(100vh - 50px)",
      height: "calc(100vh)",
      minHeight: "100%",
      top: "50px",
    };

    const overlayStyle = {
      position: "absolute",
      inset: 0,
      background: "rgba(0, 0, 0, 0.45)",
      zIndex: -1,
    };

    return (
      <div style={backgroundStyle} className='bkg-layer'>
        <div style={overlayStyle}></div>
      </div>
    );
  }
}

export default BackgroundLayer;
